// extracted by mini-css-extract-plugin
module.exports = {"wrap":"navigation-side-header_wrap__kSCJb","headline":"navigation-side-header_headline__Wumhs","headlineWrap":"navigation-side-header_headlineWrap__6Wpll"};